module.exports = __webpack_public_path__ + "static/media/logo-16.36fda847.jpg";